import styled from 'styled-components';
import { TextButton as AudiButton } from '@oneaudi/unified-web-components';
import { ArrowIcon as ArrowIconSvg } from './ArrowIcon';

export const Button = styled(AudiButton).attrs({
  className: 'mobile-layout__back-to-search',
  'data-test-id': 'mobile-layout-back-to-search',
  variant: 'primary',
  size: 'sm',
})`
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  /* background: black; */
  width: unset;
  padding-right: 12px;

  /* &.mobile-layout__back-to-search[type]:not(:disabled):hover {
    background-color: black;
  } */

  span {
    display: flex;
    align-items: center;
  }
`;

export const ArrowIcon = styled(ArrowIconSvg).attrs({
  className: 'mobile-layout__back-to-search__icon',
  'data-test-id': 'mobile-layout-back-to-search-icon',
})`
  margin-left: 10px;

  path {
    color: white;
  }
`;
